import AlertLimitedAccess from './AlertLimitedAccess';

export default AlertLimitedAccess;
